import { Link } from 'react-router-dom';
import { NavigationChevronLeft, NavigationChevronRight } from '@vibe/icons';
import { ProductLogo } from '@/components/ProductLogo';
import { useLocale } from '@/i18n/LocaleProvider';
import { useTranslation } from '@/i18n/useTranslation';
import LanguageChooser from '@/components/LanguageChooser/LanguageChooser';
import styles from './AppHeader.module.css';

interface Props {
  centerLogo?: boolean;
  /** Landing page — Eshkol logo lives in hero; header shows utilities only. */
  minimal?: boolean;
}

export default function AppHeader({ centerLogo = false, minimal = false }: Props) {
  const t = useTranslation();
  const { language } = useLocale();
  const DocsIcon = language === 'he' || language === 'ar' ? NavigationChevronLeft : NavigationChevronRight;

  const logo = (
    <Link to="/" className={styles.brandLink}>
      <ProductLogo variant="full" compact />
    </Link>
  );

  const actions = (
    <div className={styles.actions}>
      <a href="/docs/" className={styles.docsLink}>
        {t.header.docs}
        <DocsIcon size={16} />
      </a>
      <LanguageChooser />
    </div>
  );

  if (minimal) {
    return (
      <header className={styles.header}>
        <div className={`${styles.headerRow} ${styles.headerMinimal}`}>{actions}</div>
      </header>
    );
  }

  return (
    <header className={`${styles.header} ${centerLogo ? styles.headerCenter : ''}`}>
      <div className={styles.headerRow}>
        {centerLogo ? <div className={styles.brandTrack}>{logo}</div> : logo}
        {actions}
      </div>
    </header>
  );
}
